import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import { Schema } from "effect";

type SortPreference = "popularity" | "alphabetical";

type SortSection =
  | "project"
  | "integrations"
  | "organization"
  | "dashboard"
  | "platform-docs";

const SortPreferenceSchema = Schema.Literals([
  "popularity",
  "alphabetical",
]);

const SortSectionSchema = Schema.Literals([
  "project",
  "integrations",
  "organization",
  "dashboard",
  "platform-docs",
]);

const SORT_PREFERENCE_COOKIE_PREFIX = "sort-preference-";

export const getSortPreferenceServerFn = createServerFn({
  method: "GET",
})
  .validator((data: unknown): SortSection => {
    return Schema.decodeUnknownSync(SortSectionSchema)(
      data
    );
  })
  .handler(async ({ data: section }) => {
    const cookieName = `${SORT_PREFERENCE_COOKIE_PREFIX}${section}`;
    const cookieValue = getCookie(cookieName);

    // Validate cookie value or return default
    if (cookieValue) {
      try {
        return Schema.decodeUnknownSync(
          SortPreferenceSchema
        )(cookieValue);
      } catch {
        // Invalid cookie value, return default
      }
    }

    return "popularity" as SortPreference;
  });
